import React from 'react';

import * as ManifestUI from '@project44/manifest-ds';

import { HTMLFormProperty } from '../../../UIFormClient/domain/abstract/HTMLFormProperty';
import { UIDomainEnums } from '../../../UILibrary';
import { ICheckbox } from '../../../UILibrary/domain/interfaces';
import { HTMLFormElementsFactory } from '../../../UILibrary/infrastructure/factories/HTMLFormElements.factory';
import { ICheckboxHTMLFormConfig, IFormClient } from '../../domain/interface';

export class CheckboxFormProperty extends HTMLFormProperty {
  public readonly isEditable: boolean;
  public readonly isDisplayable: boolean;
  public readonly initialValue: string;
  public readonly inputType: UIDomainEnums.HTMLFormTypeEnum.CHECKBOX;
  public readonly helperText: string | undefined = undefined;
  public readonly label: string | undefined = undefined;
  public readonly name: string | undefined = undefined;

  constructor(
    protected readonly payload: Partial<ICheckboxHTMLFormConfig>,
    protected readonly additionalCheckboxProps?: Partial<ICheckbox>,
  ) {
    super();
    Object.assign(this, payload);
  }

  public readonly renderFormControlComponent: React.FC = () => {
    return null;
  };

  public renderFormTypeComponent: React.FC<{
    propertyName: string;
    formClient: IFormClient;
    isLoading?: boolean;
  }> = ({ formClient, propertyName, isLoading }) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <HTMLFormElementsFactory.composeCheckbox
          {...this.additionalCheckboxProps}
          data-testid={propertyName}
          aria-labelledby={propertyName}
          name={propertyName}
          id={propertyName}
          helperText={this.helperText}
          children={this.label}
          isDisabled={!this.isEditable || isLoading}
          isReadOnly={!this.isEditable}
          isSelected={formClient.values[propertyName] === 'true'}
          onChange={(onChangeBooleanValue) => {
            formClient.setFieldValue(
              propertyName,
              onChangeBooleanValue.toString(),
            );
            formClient.touched[propertyName] = true;
          }}
          validationState={this.setValidationStateProp(
            propertyName,
            formClient,
          )}
        />
        {this.helperText && (
          <ManifestUI.Typography
            variant={'subtext'}
            css={{ marginLeft: '25px' }}
          >
            {this.helperText}
          </ManifestUI.Typography>
        )}
      </div>
    );
  };

  public static readonly compose = (
    payload: Omit<Partial<ICheckboxHTMLFormConfig>, 'inputType'>,
    additionalCheckboxProps?: Partial<ICheckbox>,
  ): HTMLFormProperty => {
    return new CheckboxFormProperty(payload, additionalCheckboxProps);
  };
}
